import * as React from "react";
import { Popup } from "@progress/kendo-react-popup";
export const CustomEndDatePickerPopUp = (props) => {
  return (
    <Popup
      {...props}
      anchorAlign={{
        horizontal: "left",
        vertical: "left",
      }}
      popupAlign={{
        horizontal: "right",
        vertical: "center",
      }}
    />
  );
};